import "E:\\wnmp\\www\\ycf_m\\static\\mmm-cli\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "E:\\wnmp\\www\\ycf_m\\static\\mmm-cli\\node_modules\\core-js\\modules\\es6.promise.js";
import "E:\\wnmp\\www\\ycf_m\\static\\mmm-cli\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "E:\\wnmp\\www\\ycf_m\\static\\mmm-cli\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from '@/js/index/index';
import App from "./index.vue";
new Vue({
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');